import gql from 'graphql-tag';

export const CREATE_RV_PRODUCT_DISCOUNT = gql`
  mutation CreateRVProductDiscount($input: ProductDiscountInput!) {
    createRVProductDiscount(input: $input) {
      productDiscount {
        id
        xProductId
        xRefTypeId
        startDate
        endDate
        rate
        maxQuantity
        createdAt
        updatedAt
      }
      error
    }
  }
`;
